// Gradient Line Chart
import {
    Bar
} from 'vue-chartjs'

import { helpers } from 'chart.js'

import {
    ChartConfig
} from "Constants/chart-config"
import {
    hexToRgbA
} from 'Helpers/helpers'
import { strictEqual } from 'assert';


const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
})

const labelFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
})

export default {
    extends: Bar,
    data() {
        return {
            gradient: null,
            gradient2: null,
            defaultSeriesSettings: {
                pointBorderWidth: 10,
                pointHoverRadius: 10,
                pointHoverBorderWidth: 1,
                pointRadius: 3,
                fill: true,
                // backgroundColor: this.values.map(item => item.color), // this.gradient2,
                borderWidth: 1
            }
        }
    },
    props: {
        sets: {
            type: Array,
            required: true
        },
        isMoneyValue: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        sets: function (val) {
            if (val.length > 0) {
                this.render()
            }
        },
    },
    methods: {
        render() {
            const self = this
            // self.$refs.canvas.height = self.height * 35
            const labels = []
            let i = 0
            const dataSets = this.sets.map(({name, data, type }) => {
                const set = {
                    data: data.map(item => {
                        if (!labels.includes(item.label)) {
                            labels.push(item.label)
                        }
                        return item.value
                    })
                }
                set.label = name
                set.type = type || 'bar'
                if (type === 'line') {
                    set.fill = false
                    set.borderWidth = 2
                }
                return Object.assign({}, this.defaultSeriesSettings, set)
            })
            // console.log(self.$refs.canvas.height)
            this.renderChart({
                labels,
                datasets: dataSets
            }, {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: dataSets.length > 1 ? true : false,
                    position: 'bottom'
                },
                scales: {
                    yAxes: [{
                      ticks: {
                        beginAtZero: true,
                        callback: function(value) {
                            return `${self.isMoneyValue ? labelFormatter.format(value) : value}`
                        }
                      }
                    }],
                    xAxes: [{
                        ticks: {
                            autoSkip: false,
                            maxRotation: 45,
                            minRotation: 45
                        }
                    }]
                },
                plugins: {
                    colorschemes: {
                        scheme: 'tableau.Classic20',
                        custom: function(schemeColors) {
                            if (dataSets.length > 1) {
                                return schemeColors.map(color => helpers.color(color).alpha(0.5).rgbString())
                            }
                            return schemeColors; // optional: this is not needed if the array is modified in place

                        }
                    }
                },
                tooltips: {
                    callbacks: {
                      label: function(tooltipItem, data) {
                        const dataValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                        const label = data.labels[tooltipItem.index]
                        return `${self.isMoneyValue ? formatter.format(dataValue) : dataValue}`
                      }
                    }
                }
            })
        }
    },
    mounted() {
        this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(500, 0, 100, 0)
        this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(500, 0, 100, 0)

        this.gradient.addColorStop(0, ChartConfig.color.danger)
        this.gradient.addColorStop(1, ChartConfig.color.warning)

        this.gradient2.addColorStop(0, hexToRgbA(ChartConfig.color.danger, 0.6))
        this.gradient2.addColorStop(1, hexToRgbA(ChartConfig.color.warning, 0.6))
        this.render()
    }
}